import { useEffect, useState } from 'react';
import { Select, Skeleton } from '@backstage/ui';

const MultiSelect = Select as any;
import {
  FieldExtensionComponentProps,
} from '@backstage/plugin-scaffolder-react';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import { useApi } from '@backstage/core-plugin-api';
import { Entity } from '@backstage/catalog-model';

export const MultiSectorSelectField = ({ 
    formData, onChange, schema }: FieldExtensionComponentProps<string[]>) => {
    
    const label = schema.title ?? 'Sectors';
    const catalogApi = useApi(catalogApiRef);
    const [options, setOptions] = useState<
      { label: string; id: string }[] | undefined
    >();

    // Load Components (kind=Component && spec.type !== 'project')
    useEffect(() => {
      const load = async () => {
        const entities: Entity[] = [];

        const resp = await catalogApi.getEntities({
          filter: { kind: 'Domain', 'metadata.namespace': 'sectors' },
          fields: [
            'metadata.name',
            'metadata.title',
            'metadata.namespace',
            'spec.type',
          ],
          limit: 1000,
        });

        entities.push(...resp.items);
        setOptions(
          entities
            .filter(e => e.spec?.type !== 'project')
            .map(e => ({
              label: e.metadata.title ?? e.metadata.name,
              id: `domain:${e.metadata.namespace ?? 'sectors'}/${e.metadata.name}`,
            })),
        );
      };
      load();
    }, [catalogApi]);

    if (!options) {
      return <Skeleton />;
    }

    return (
      <MultiSelect
        label={label}
        selectionMode="multiple"
        selectedKeys={new Set(formData ?? [])}
        onSelectionChange={(keys: Set<string>) => onChange(Array.from(keys))}
        options={options}
      />
    );
  };
